import { BaseModel } from '../../base/models/base-model.model';

export class RoleModel extends BaseModel {

  private _active: boolean;
  private _description?: string;
  private _validFrom?: Date;
  private _validUntil?: Date;

  constructor(active: boolean, description?: string, validFrom?: Date, validUntil?: Date ) {
		super();
		this._active = active;
    this._description = description;
    this._validFrom = validFrom;
    this._validUntil = validUntil;
	}

  public get id(): string {
		return this._id;
	}

	public set id(value: string) {
    this._id = value;
	}

  public get active(): boolean {
    return this._active;
  }

  public set active(value: boolean) {
    this._active = value;
  }

  public get description(): string {
    return this._description;
  }

  public set description(value: string) {
    this._description = value;
  }


  public get validFrom(): Date {
    return this._validFrom;
  }

  public set validFrom(value: Date) {
    this._validFrom = value;
  }

  public get validUntil(): Date {
    return this._validUntil;
  }

  public set validUntil(value: Date) {
    this._validUntil = value;
  }

}